<template>
  <page-list
    :list="list"
    :columns="changedColumns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :showGroupActions="showGroupActions"
    :export-data-options="exportDataOptions">
    <template v-slot:group-actions-append v-if="!defaultDate">
      <date-time
        class="ml-2"
        :getParams.sync="dateParam"
        :dateMode.sync="dateMode"
        paramTimeFormatter="YYYY-MM-DDTZ"
        showStartMonthTip
        @refresh="fetchData" />
    </template>
    <template v-slot:table-prepend>
      <total-price :currencySign="currencySign" :total="total_amount" :secondary_total="total_secondary_amount" setSecondaryToAmount />
    </template>
  </page-list>
</template>

<script>
import * as R from 'ramda'
import TotalPrice from '@Bill/sections/TotalPrice'
import ContractMixin from '@Bill/mixins/contract'
import currencyRequest from '@Bill/mixins/currencyRequest'
import TotalPriceMixin from '@Bill/mixins/totalPrice'
import { getAmountColumns } from '@Bill/utils'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CloudProjectList',
  components: {
    TotalPrice,
  },
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, currencyRequest, TotalPriceMixin, ContractMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
    cloudEnv: String,
    isAllowCreate: {
      type: Boolean,
      default: true,
    },
    hiddenActions: {
      type: Array,
      default: () => ([]),
    },
    defaultDate: Object,
    defaultDateMode: String,
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    return {
      batchDeleteBill: true,
      dateMode: this.defaultDateMode || 'month',
      dateParam: this.defaultDate || {},
      list: this.$list.createList(this, {
        id: this.id,
        apiVersion: 'v1',
        idKey: 'brand',
        exportUseIdKey: true,
        resource: 'billsanalysises',
        getParams: this.getParam,
        fetchDataCb: this.getTotal,
        filterOptions: {
          name: {
            label: this.$t('table.title.name'),
            filter: true,
            formatter: val => {
              return `brand.contains('${val}')`
            },
          },
        },
      }),
    }
  },
  computed: {
    changedColumns () {
      const columns = R.clone(this.columns)
      const amountColumns = getAmountColumns({
        disable_cost_conversion: this.currencyParams.disable_cost_conversion,
        dateMode: this.dateMode,
        amountContractColumn: this.billContractColumns[0] || null,
        currencySign: this.currencySign,
      })
      return [...columns, ...amountColumns]
    },
    exportDataOptions () {
      const items = this.changedColumns.map(item => {
        return {
          key: item.field,
          label: item.title,
        }
      })
      return { items }
    },
  },
  watch: {
    currencyParams: {
      handler: function () {
        this.fetchData()
      },
    },
    deep: true,
    billShared () {
      this.fetchData()
    },
    projectShared () {
      this.fetchData()
    },
  },
  created () {
    this.initSidePageTab('overview')
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    getParam () {
      const getParams = (R.is(Function, this.getParams) ? this.getParams() : this.getParams)
      const ret = {
        details: false,
        query_type: 'platform_brand_expense',
        start_date: this.$moment().startOf('month').format('YYYY-MM-DD') + 'TZ',
        end_date: this.$moment().endOf('month').format('YYYY-MM-DD') + 'TZ',
        ...this.currencyParams,
        ...getParams,
        ...this.dateParam,
        ...(this.billContractParams || {}),
      }
      if (getParams.filter) {
        // delete ret.filter
        ret.filter = [this.currencyParams.filter, getParams.filter]
      }
      if (this.billShared) {
        ret.is_prepaid_amortizing = true
      } else {
        ret.is_prepaid_amortizing = false
      }
      if (this.projectShared) {
        ret.is_project_sharing = true
      } else {
        ret.is_project_sharing = false
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillBrandSidePage', {
        id: row.brand,
        resource: () => {
          return {
            data: row,
          }
        },
        apiVersion: 'v1',
        getParams: this.getParams,
        dateParam: this.dateParam,
        dateMode: this.dateMode,
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
